/* tslint:disable variable-name */
import { VERSION } from '../utils/config';
import { dataSet, parseVyData, log, getQueryParam } from '../utils/embed-helpers';

class DataParams {
  public autoplay: number;
  public custom_id?: string;
  public disable_popouts = 1;
  public height?: string;
  public overlayZindex?: number;
  public rendered?: 'true';
  public type: 'inline' | 'lightbox';
  public uuid: string;
  public v: string;
  public vyemail?: string;
  public vyetoken?: string;
  public vysfid?: string;
  public width?: string;
  public playlist_always_open?: string;
  public backlink?: number;
  public alt?: string;

  constructor(placeHolderImage: HTMLImageElement) {
    const data = parseVyData(dataSet(placeHolderImage));
    Object.keys(data).forEach((key) => {
      this[key] = data[key];
    });

    // Pass-through the placeholder's thumbnail alt value. Set by the host (e.g. Shire).
    this.alt = placeHolderImage.alt || null;

    // Default to inline embed
    if (this.type !== 'inline' && this.type !== 'lightbox') {
      log('Invalid Vidyard player embed type, defaulting to inline.', 'warn');
      this.type = 'inline';
    }

    // Report the embed script version
    this.v = VERSION;
    // This embed code no longer supports popout CTAs
    this.disable_popouts = 1;
    // Gets the vycustomid query string param, used to identify personalized videos
    this.custom_id = this.custom_id || getQueryParam('vycustom_id');
    // Gets the vyemail query string param, which connects views to an email entered
    this.vyemail = this.vyemail || getQueryParam('vyemail');
    // Sets a fixed Vidyard Salesforce ID for every view
    this.vysfid = this.vysfid || getQueryParam('vysfid');
    // Sets a fixed Vidyard Salesforce ID for every view
    this.vyetoken = this.vyetoken || getQueryParam('vyetoken');
  }

  public toQueryString() {
    let queryParamsString = '?';
    let key: string;

    for (key in this) {
      if (!this.hasOwnProperty(key)) {
        continue;
      }

      // Don't include these params in the query string
      if (key === 'height' || key === 'uuid' || key === 'width' || key === 'alt') {
        continue;
      }

      // Don't include undefined keys
      if (this[key] === undefined) {
        continue;
      }

      // Add '&' here so we don't end up with one trailing
      queryParamsString += queryParamsString !== '?' ? '&' : '';
      queryParamsString += encodeURIComponent(key) + '=' + encodeURIComponent(this[key]);
    }

    // Just return an empty string if no params were found
    return queryParamsString === '?' ? '' : queryParamsString;
  }
}

export default DataParams;
